/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIStorageArticleAutocompleteSuggestion } from './APIStorageArticleAutocompleteSuggestion';
import {
    APIStorageArticleAutocompleteSuggestionFromJSON,
    APIStorageArticleAutocompleteSuggestionFromJSONTyped,
    APIStorageArticleAutocompleteSuggestionToJSON,
} from './APIStorageArticleAutocompleteSuggestion';

/**
 * 
 * @export
 * @interface APIStorageArticleAutocompleteResponse
 */
export interface APIStorageArticleAutocompleteResponse {
    /**
     * 
     * @type {Array<APIStorageArticleAutocompleteSuggestion>}
     * @memberof APIStorageArticleAutocompleteResponse
     */
    suggestions: Array<APIStorageArticleAutocompleteSuggestion>;
    /**
     * 
     * @type {number}
     * @memberof APIStorageArticleAutocompleteResponse
     */
    total: number;
}

/**
 * Check if a given object implements the APIStorageArticleAutocompleteResponse interface.
 */
export function instanceOfAPIStorageArticleAutocompleteResponse(value: object): value is APIStorageArticleAutocompleteResponse {
    if (!('suggestions' in value) || value['suggestions'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function APIStorageArticleAutocompleteResponseFromJSON(json: any): APIStorageArticleAutocompleteResponse {
    return APIStorageArticleAutocompleteResponseFromJSONTyped(json, false);
}

export function APIStorageArticleAutocompleteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIStorageArticleAutocompleteResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'suggestions': ((json['suggestions'] as Array<any>).map(APIStorageArticleAutocompleteSuggestionFromJSON)),
        'total': json['total'],
    };
}

export function APIStorageArticleAutocompleteResponseToJSON(value?: APIStorageArticleAutocompleteResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'suggestions': ((value['suggestions'] as Array<any>).map(APIStorageArticleAutocompleteSuggestionToJSON)),
        'total': value['total'],
    };
}

